import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { savePushSubscription } from '../service/apiService';
import { urlBase64ToUint8Array } from '../utils/pushUtils';

/**
 * Hook para gerenciar subscrição de Push Notifications
 * Solicita automaticamente permissao para usuarios autenticados
 */
export const usePushNotifications = () => {
    const { user, getAccessToken, isAuthenticated } = useAuth();

    useEffect(() => {
        const subscribeToPush = async () => {
            // Apenas para usuarios autenticados
            if (!isAuthenticated || !user) {
                return;
            }

            // Verifica suporte do navegador
            if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
                console.warn('[Push] Navegador não suporta push notifications');
                return;
            }

            try {
                const registration = await navigator.serviceWorker.ready;
                console.log('[Push] Service Worker pronto');

                const currentPermission = Notification.permission;
                console.log('[Push] Permissão atual:', currentPermission);

                // Verifica se já existe inscrição
                let subscription = await registration.pushManager.getSubscription();

                if (currentPermission !== 'granted') {
                    console.log('[Push] Solicitando permissão...');
                    const permission = await Notification.requestPermission();
                    if (permission !== 'granted') {
                        console.warn('[Push] Permissão negada pelo usuário');
                        return;
                    }
                }

                // Busca a chave VAPID das variáveis de ambiente
                const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;

                if (!vapidKey) {
                    console.error('[Push] REACT_APP_VAPID_PUBLIC_KEY não configurada');
                    return;
                }

                if (!subscription) {
                    console.log('[Push] Criando nova subscrição...');
                    subscription = await registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(vapidKey)
                    });
                }

                // Envia subscrição para o backend
                const token = getAccessToken();
                if (token && subscription) {
                    await savePushSubscription(subscription, token);
                    console.log('[Push] Subscrição sincronizada com o backend!');
                }

            } catch (error) {
                console.error('[Push] Erro ao gerenciar subscrição:', error);
            }
        };

        subscribeToPush();
    }, [isAuthenticated, user, getAccessToken]);
};
